import { acClient } from '@/clients/ac-client.js';
import { backboneService } from '@/services/backbone.js';
import { toastService } from '@/services/toast.js';
import { HatElement } from '@/components/hat-element.js';

class HatAdminInvitationDetail extends HatElement {
  private _invitation: any = null;

  connectedCallback() {
    super.connectedCallback();
    const id = this.getAttribute('invitation-id');
    this.root.innerHTML = `<p style="color:white;opacity:0.7">Loading…</p>`;
    this.load(id);
  }

  async load(id: string | null) {
    if (!id) return;
    try {
      this._invitation = await acClient.getInvitation(id);
      this.render();
    } catch {
      toastService.show('Failed to load invitation.');
      this.root.innerHTML = `<p style="color:white;opacity:0.7">Could not load invitation.</p>`;
    }
  }

  async handleDelete() {
    if (!confirm('Delete this invitation?')) return;
    try {
      await acClient.deleteInvitation(this._invitation.invitationId);
      toastService.show('Invitation deleted.', 'success');
      backboneService.navigateTo('/admin/invitations');
    } catch {
      toastService.show('Failed to delete invitation.');
    }
  }

  render() {
    const inv = this._invitation;
    const fmt = (ts: string) => new Date(ts).toLocaleString();

    this.root.innerHTML = `
      <style>
        h2 {
          color: white;
          font-size: 1.4rem;
          margin: 0 0 24px;
          text-shadow: 0 2px 4px rgba(0,0,0,0.3);
        }

        .back-link {
          display: inline-block;
          margin-bottom: 16px;
          color: rgba(255,255,255,0.8);
          cursor: pointer;
          font-size: 0.9rem;
          background: none;
          border: none;
          padding: 0;
          text-shadow: 0 1px 3px rgba(0,0,0,0.3);
        }

        .back-link:hover { color: white; }

        .card {
          background: white;
          border-radius: 12px;
          padding: 28px;
          max-width: 520px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .field {
          display: flex;
          flex-direction: column;
          gap: 3px;
          padding: 14px 0;
          border-bottom: 1px solid #f0f0f0;
        }

        .field:first-child { padding-top: 0; }
        .field:last-of-type { border-bottom: none; padding-bottom: 0; }

        .label {
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          color: #aaa;
        }

        .value { font-size: 0.95rem; color: #222; }

        .status {
          display: inline-block;
          padding: 2px 10px;
          border-radius: 12px;
          font-size: 0.82rem;
          font-weight: 600;
        }

        .status-pending  { background: #fef3c7; color: #92400e; }
        .status-redeemed { background: #d1fae5; color: #065f46; }
        .status-revoked  { background: #fee2e2; color: #991b1b; }

        .danger-zone {
          margin-top: 24px;
          padding-top: 20px;
          border-top: 1px solid #f0f0f0;
        }

        .btn-danger {
          background: #c0392b;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          font-size: 0.9rem;
        }

        .btn-danger:hover { opacity: 0.85; }
      </style>

      <button class="back-link">← Back to Invitations</button>
      <h2>Invitation</h2>

      <div class="card">
        <div class="field">
          <span class="label">Email</span>
          <span class="value">${inv.email}</span>
        </div>
        <div class="field">
          <span class="label">Type</span>
          <span class="value">${inv.type}</span>
        </div>
        <div class="field">
          <span class="label">Status</span>
          <span class="value">
            <span class="status status-${inv.status.toLowerCase()}">${inv.status}</span>
          </span>
        </div>
        <div class="field">
          <span class="label">Created</span>
          <span class="value">${inv.createdBy} &middot; ${fmt(inv.createdTS)}</span>
        </div>
        <div class="field">
          <span class="label">Last modified</span>
          <span class="value">${inv.modifiedBy} &middot; ${fmt(inv.modifiedTS)}</span>
        </div>

        <div class="danger-zone">
          <button class="btn-danger" id="delete-btn">Delete Invitation</button>
        </div>
      </div>
    `;

    this.root.querySelector('.back-link')!.addEventListener('click', () => {
      backboneService.navigateTo('/admin/invitations');
    });

    this.root.getElementById('delete-btn')!.addEventListener('click', () => {
      this.handleDelete();
    });
  }
}

customElements.define('hat-admin-invitation-detail', HatAdminInvitationDetail);